import { jsx as n, jsxs as c, Fragment as D } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { faEllipsisV as M, faSquare as I, faCheck as v, faChevronRight as C } from "@fortawesome/pro-regular-svg-icons";
import { faSquareCheck as S } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as l } from "@fortawesome/react-fontawesome";
import * as r from "@radix-ui/react-dropdown-menu";
import { Button as R } from "../button/Button.js";
import { Separator as A } from "../separator/Separator.js";
import { twMerge as s } from "tailwind-merge";
const T = (e) => /* @__PURE__ */ n(r.Root, { ...e }), u = i(
  ({ className: e, "aria-label": o, ...t }, a) => /* @__PURE__ */ n(
    x,
    {
      asChild: !0,
      ref: a,
      className: s(
        "flex h-7 items-center justify-center rounded px-3 py-4 hover:bg-gray-300",
        e
      ),
      "aria-label": o ?? "More actions",
      ...t,
      children: /* @__PURE__ */ n(R, { variant: "none", children: /* @__PURE__ */ n(l, { icon: M }) })
    }
  )
);
u.displayName = "DropdownMenuEllipsisTrigger";
const g = i(
  ({ className: e, ...o }, t) => /* @__PURE__ */ n(y, { children: /* @__PURE__ */ n(
    r.Content,
    {
      className: s(
        "z-pentOutermost shadow-popover max-h-[--radix-dropdown-menu-content-available-height] min-w-[200px] overflow-y-auto rounded-lg bg-white p-1",
        e
      ),
      ref: t,
      ...o
    }
  ) })
);
g.displayName = r.Content.displayName;
const G = ({
  className: e,
  ...o
}) => /* @__PURE__ */ n(
  r.DropdownMenuLabel,
  {
    className: s("select-none p-2 text-xs font-medium leading-4 text-[#bababa]", e),
    ...o
  }
), m = i(
  ({ className: e, disabled: o, onClick: t, ...a }, d) => /* @__PURE__ */ n(
    r.Item,
    {
      ref: d,
      className: s(
        "radix-disabled:cursor-not-allowed radix-disabled:hover:bg-transparent radix-disabled:opacity-60 cursor-pointer rounded-lg p-2 text-sm font-medium leading-4 outline-none hover:bg-gray-100 focus:bg-gray-100",
        e
      ),
      disabled: o,
      onClick: o ? void 0 : t,
      ...a
    }
  )
);
m.displayName = r.Item.displayName;
const k = ({ className: e, ...o }) => /* @__PURE__ */ n(
  l,
  {
    className: s("ml-auto pr-2", e),
    size: "sm",
    icon: C,
    ...o
  }
), w = ({
  children: e,
  className: o,
  disabled: t,
  ...a
}) => /* @__PURE__ */ n(
  "a",
  {
    className: s(
      "text-gray-900 no-underline hover:text-gray-900",
      t && "pointer-events-none",
      o
    ),
    ...a,
    children: /* @__PURE__ */ n(
      m,
      {
        className: "focus-visible:before:border-0",
        onSelect: (d) => d.preventDefault(),
        disabled: t,
        children: e
      }
    )
  }
);
w.displayName = "DropdownMenuAnchorItem";
const b = i(
  ({ className: e, checked: o, onSelect: t, children: a, ...d }, N) => /* @__PURE__ */ n(
    r.CheckboxItem,
    {
      ref: N,
      onSelect: (p) => {
        p.preventDefault(), t == null || t(p);
      },
      checked: o,
      className: s(
        "radix-highlighted:bg-gray-100 radix-disabled:cursor-not-allowed radix-disabled:opacity-60 -m-1 flex cursor-pointer items-center gap-1.5 rounded-md p-1 outline-none",
        e
      ),
      ...d,
      children: typeof a == "string" ? /* @__PURE__ */ c(D, { children: [
        /* @__PURE__ */ n(
          l,
          {
            className: o ? "text-blue-500" : "text-gray-200",
            icon: o ? S : I
          }
        ),
        /* @__PURE__ */ n("p", { className: "text-sm font-medium", children: a })
      ] }) : a
    }
  )
);
b.displayName = r.CheckboxItem.displayName;
const h = i(
  ({ children: e, className: o, ...t }, a) => /* @__PURE__ */ c(
    r.RadioItem,
    {
      ref: a,
      className: s(
        "radix-disabled:cursor-not-allowed radix-disabled:opacity-60 flex cursor-pointer items-center justify-between gap-2 rounded-lg p-2 text-sm font-medium leading-4 outline-none hover:bg-gray-200 focus:bg-gray-200",
        o
      ),
      ...t,
      children: [
        e,
        /* @__PURE__ */ n(O, { children: /* @__PURE__ */ n("div", { className: "[&>svg]:text-brand-cobalt-primary size-4 [&>svg]:h-full [&>svg]:w-full", children: /* @__PURE__ */ n(l, { icon: v }) }) })
      ]
    }
  )
);
h.displayName = r.RadioItem.displayName;
const f = i(
  ({ className: e, ...o }, t) => /* @__PURE__ */ n(
    r.SubContent,
    {
      className: s(
        "z-pentOutermost shadow-popover max-h-[--radix-dropdown-menu-content-available-height] min-w-[200px] overflow-y-auto rounded-lg bg-white p-1",
        e
      ),
      ref: t,
      ...o
    }
  )
);
f.displayName = r.SubContent.displayName;
const j = ({
  className: e,
  ...o
}) => /* @__PURE__ */ n(r.Arrow, { className: s("fill-white", e), ...o }), x = r.Trigger, z = r.Group, E = r.ItemIndicator, P = r.RadioGroup, L = r.Sub, q = r.SubTrigger, y = r.Portal, F = A, W = T, X = x, Y = u, Z = g, _ = G, oo = z, eo = m, ro = k, no = w, to = b, ao = P, so = h, O = E, io = L, lo = f, mo = q, po = j, co = F, uo = y;
export {
  no as AnchorItem,
  po as Arrow,
  to as CheckboxItem,
  Z as Content,
  T as DropdownMenu,
  w as DropdownMenuAnchorItem,
  j as DropdownMenuArrow,
  b as DropdownMenuCheckboxItem,
  g as DropdownMenuContent,
  u as DropdownMenuEllipsisTrigger,
  z as DropdownMenuGroup,
  m as DropdownMenuItem,
  k as DropdownMenuItemArrow,
  E as DropdownMenuItemIndicator,
  G as DropdownMenuLabel,
  y as DropdownMenuPortal,
  P as DropdownMenuRadioGroup,
  h as DropdownMenuRadioItem,
  F as DropdownMenuSeparator,
  L as DropdownMenuSub,
  f as DropdownMenuSubContent,
  q as DropdownMenuSubTrigger,
  x as DropdownMenuTrigger,
  Y as EllipsisTrigger,
  oo as Group,
  eo as Item,
  ro as ItemArrow,
  O as ItemIndicator,
  _ as Label,
  uo as Portal,
  ao as RadioGroup,
  so as RadioItem,
  W as Root,
  co as Separator,
  io as Sub,
  lo as SubContent,
  mo as SubTrigger,
  X as Trigger
};
